import { SyncEntity } from "../src/entity/Sync";
import { Constants } from "./constants";
import { SyncDirection } from "./sesh_types";

export namespace sync_utils {
	export function isSyncLimitReached(
		syncs: SyncEntity[],
		sync_direction: SyncDirection,
		is_premium: boolean,
		has_sesh_pro: boolean = false
	) {
		if (sync_direction === SyncDirection.Bidirectional) {
			return (
				isSyncLimitReached(syncs, SyncDirection.Inbound, is_premium, has_sesh_pro) ||
				isSyncLimitReached(syncs, SyncDirection.Outbound, is_premium, has_sesh_pro)
			);
		}

		const amount = syncs.filter(
			(val) => val.sync_direction === sync_direction
		).length;

		const tier = has_sesh_pro ? "sesh_pro" : is_premium ? "premium" : "standard";
		return amount >= Constants.SYNC_LIMITS[sync_direction][tier];
	}
}
